import { useEffect, useState } from "react";
import "./App.css";
import { RouterProvider } from "react-router-dom";
import { router } from "./routes/routeDefinitions";
import { Store } from "./context/store";
import { TopNotification } from "./components/TopNotification";
import { Company } from "./modules/home/models/Company";
import { config } from "./config";

function App() {
  const [showNotifications, setShowNotifications] = useState(false);
  const [notificationStatus, setNotificationStatus] = useState(false);
  const [notificationCopy, setNotificationCopy] = useState("");
  const [notificationHeader, setNotificationHeader] = useState("");
  const clientCode = window.location.pathname.split("/")[1];
  const [company, setCompany] = useState<Company>();

  useEffect(() => {
    if (window.location.pathname === "/") {
      document.location.href = "https://www.hr-flex.com/";
    }
  }, []);
  return (
    <>
      <Store.Provider
        value={{
          baseUrl: config.baseUrl,
          apiKey: config.apiKey,
          showNotification: showNotifications,
          setShowNotification: setShowNotifications,
          notificationCopy: notificationCopy,
          setNotificationCopy: setNotificationCopy,
          notificationHeader: notificationHeader,
          setNotificationHeader: setNotificationHeader,
          notificationStatus: notificationStatus,
          setNotificationStatus: setNotificationStatus,
          code: clientCode,
          setCompany: setCompany,
          company: company,
        }}
      >
        {/* Opts into React Router v7's default now (state updates wrapped in startTransition), which also
            silences the future-flag warning it prints on every load. */}
        <RouterProvider router={router} future={{ v7_startTransition: true }} />
        <div className="fixed z-50">
          <TopNotification />
        </div>
      </Store.Provider>
    </>
  );
}

export default App;
